import { supabase } from './supabase'

// Public shape of a Customer Showcase entry as returned by the get_public_showcase()
// reader (mig 347). PUBLIC fields only — the internal contact note never crosses the
// wire. Shared by the marketing homepage; the admin screen has its own fuller type.
export interface PublicShowcaseEntry {
  id: string
  quote: string
  company_name: string
  location: string | null
  owner_photo_url: string | null
  slide_images: string[] | null
  website_url: string | null
  instagram_url: string | null
  facebook_url: string | null
  tiktok_url: string | null
  whatsapp_url: string | null
}

// Fetch Published showcase entries for the public homepage. FAILS SOFT: if the reader
// RPC is not deployed yet (mig 347 not applied) or errors, returns [] so the homepage
// falls back to the design's static placeholder testimonials rather than breaking.
export async function fetchPublicShowcase(): Promise<PublicShowcaseEntry[]> {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data, error } = await (supabase as any).rpc('get_public_showcase')
    if (error) return []
    const arr = Array.isArray(data) ? data : []
    return arr as PublicShowcaseEntry[]
  } catch {
    return []
  }
}
